module.exports = __webpack_public_path__ + "img/wordpress.fc387c41.svg";